// Default CRM board payload so the first click on CRM is cache-first.

const CACHE_TTL_MS = 2 * 60 * 1000;

let _cache = {};

export function crmBoardQueryKey({
  search = '',
  agentId = '',
  leadType = '',
  hideConverted = true,
  ad = '',
  sort = 'newest',
} = {}) {
  const p = new URLSearchParams();
  if (search) p.set('search', search);
  if (agentId) p.set('agentId', agentId);
  if (leadType) p.set('leadType', leadType);
  if (hideConverted) p.set('hideConverted', 'true');
  if (ad) p.set('ad', ad);
  if (sort && sort !== 'newest') p.set('sort', sort);
  return p.toString();
}

function slot(userId, queryKey) {
  return `${userId}::${queryKey || ''}`;
}

export function getCrmBoardCache(userId, queryKey) {
  if (!userId) return null;
  const entry = _cache[slot(userId, queryKey)];
  if (!entry) return null;
  if (Date.now() - entry.ts > CACHE_TTL_MS) {
    delete _cache[slot(userId, queryKey)];
    return null;
  }
  return entry.data;
}

export function setCrmBoardCache(userId, queryKey, data) {
  if (!userId || !data) return;
  _cache[slot(userId, queryKey)] = { data, ts: Date.now() };
}

export function invalidateCrmBoardCache(userId) {
  if (!userId) {
    _cache = {};
    return;
  }
  const prefix = `${userId}::`;
  Object.keys(_cache).forEach((k) => {
    if (k.startsWith(prefix)) delete _cache[k];
  });
}
